import { h, JSX } from "@stencil/core";
import { isString } from "@phn/utility/helper";

export default function MenuItemText({
  text,
  size,
  subtext,
  fontWeight,
}: {
  text: string;
  size: string;
  subtext: string;
  fontWeight: string;
}): JSX.Element {
  return (
    <div class="skeleton-item">
      <phn-p-text size={size} color="inherit" tag="div" weight={fontWeight}>
        {text}
      </phn-p-text>

      {isString(subtext) ? (
        <div class="text-limit fs-mask" data-cs-mask>
          <phn-p-text
            class={"subtext"}
            color={"inherit"}
            weight="regular"
            size="x-small"
            tag="div"
            ellipsis="true"
            data-test-id="subtext"
          >
            {subtext}
          </phn-p-text>
        </div>
      ) : null}
    </div>
  );
}
